import { Component, OnInit, Input, Output, EventEmitter, HostListener, ElementRef } from '@angular/core';
import { TripPaymentFilter } from '../../../models/trips/trip.payment.filter';

@Component({
  selector: 'trip-payment-filter',
  templateUrl: './trip-payment-filter.component.html',
  styleUrls: ['./trip-payment-filter.component.css']
})
export class TripPaymentFilterComponent implements OnInit {
	showFilter: boolean = false;
	
	@Input() filter: TripPaymentFilter = new TripPaymentFilter();
	@Output() search: EventEmitter<TripPaymentFilter> = new EventEmitter<TripPaymentFilter>()
	
	@HostListener('document:click', ['$event'])
	clickout(event) {
		if (!this._elementRef.nativeElement.contains(event.target))
			this.showFilter = false;
	}

	constructor(private _elementRef: ElementRef,) { }

	ngOnInit() {
	}

	toggleFilter() {
		this.showFilter = !this.showFilter;
	}

	onSearchClick() {
		this.search.emit(this.filter);
		this.showFilter = false;
	}

	onClearClick() {
        this.filter.clientId = null;
		this.filter.tripId = null;
		this.filter.paymentType = null;
		this.filter.remarks = null;
		this.filter.checkDueDateFrom = null;
		this.filter.checkDueDateTo = null;
		this.filter.createdDate = null;
		this.filter.dateRecieved = null;
	}
}



// WEBPACK FOOTER //
// ./src/app/components/trips/trip-payment-filter/trip-payment-filter.component.ts